import Phaser from 'phaser'
import { t } from '../../i18n'
import { DESIGN_HEIGHT, DESIGN_WIDTH } from '../JKGame_dims'
import { COLORS, FONT, hasFinePointer, prefersReducedMotion } from '../JKGame_ui'

export class JKGame_BootScene extends Phaser.Scene {
  constructor() {
    super('Boot')
  }

  create(): void {
    const cx = DESIGN_WIDTH / 2
    this.cameras.main.setBackgroundColor(COLORS.bg)

    const title = this.add.text(cx, DESIGN_HEIGHT * 0.3, t('app.title'), {
      fontFamily: FONT,
      fontSize: '66px',
      color: COLORS.text,
      fontStyle: 'bold',
    }).setOrigin(0.5)
    // Shrink to fit so a wide localized title (e.g. en) never clips at the edges.
    const maxTitleW = DESIGN_WIDTH - 32
    if (title.width > maxTitleW) title.setScale(maxTitleW / title.width)

    const subtitle = this.add.text(cx, DESIGN_HEIGHT * 0.3 + 70, t('app.subtitle'), {
      fontFamily: FONT,
      fontSize: '22px',
      color: COLORS.sub,
    }).setOrigin(0.5)
    // Fit the subtitle too (the title already fits) so a wide localized tagline never clips.
    if (subtitle.width > maxTitleW) subtitle.setScale(maxTitleW / subtitle.width)

    const hint = this.add.text(cx, DESIGN_HEIGHT * 0.5, t('boot.hint'), {
      fontFamily: FONT,
      fontSize: '20px',
      color: COLORS.sub,
      align: 'center',
    }).setOrigin(0.5)
    if (hint.width > maxTitleW) hint.setScale(maxTitleW / hint.width) // fit (parity with title/subtitle/tap)

    const tap = this.add.text(cx, DESIGN_HEIGHT * 0.66, t('boot.tap'), {
      fontFamily: FONT,
      fontSize: '30px',
      color: COLORS.good,
    }).setOrigin(0.5)
    if (tap.width > maxTitleW) tap.setScale(maxTitleW / tap.width) // fit (parity with title/subtitle)
    // Decorative "tap" pulse; skip under prefers-reduced-motion (the text stays visible).
    if (!prefersReducedMotion()) this.tweens.add({ targets: tap, alpha: 0.3, duration: 700, yoyo: true, repeat: -1 })

    // Desktop-only discoverability hint for the keyboard controls (hidden on touch).
    if (hasFinePointer()) {
      this.add.text(cx, DESIGN_HEIGHT - 48, t('boot.kbd'), {
        fontFamily: FONT, fontSize: '14px', color: COLORS.sub, align: 'center',
        wordWrap: { width: DESIGN_WIDTH - 48, useAdvancedWrap: true },
      }).setOrigin(0.5)
    }

    this.input.once('pointerup', () => this.scene.start('Menu'))
    this.input.keyboard?.once('keydown', () => this.scene.start('Menu')) // any key starts (desktop)
  }
}
